#!/usr/bin/env node
import log from 'loglevel'
import { initLogger } from '../util/logger'
import cliStage, { cliStageOptions } from './cliStage';
import { Command, Option } from 'commander'
import cliDeploy, { cliDeployOptions } from './cliDeploy';
import cliCreateEnv, { cliCreateEnvOptions } from './cliCreateEnv';
import { cliCreateCiConfig, cliCreateCiConfigOptions } from './cliCreateCiConfig';

import { defaultCiConfigFile, defaultDeployConfigFile } from '../index'

const program = new Command();

const cli = async () => {
  try {


    // Stage command
    program
      .command('stage')
      .addOption(
        new Option('-s, --stage <name>', 'Stage you would like to run')
          .choices(['deploy', 'build', 'stop', 'revert'])
      )
      .addOption(
        new Option('-p, --phase <phase>', 'Phase you would like to run')
          .choices(['before', 'main', 'after'])
      )
      .option('-c, --config <path>', 'Path to ci config file', defaultCiConfigFile)
      .description('Load config and run configured stage scripts')
      .action(async (options: cliStageOptions) => {
        log.debug(`Running cli stage with options ${JSON.stringify(options)}`)
        await cliStage(options)
      })

    // Phase command
    program
      .command('deploy')
      .addOption(
        new Option('-a, --action [action]', 'Deploy action')
          .choices(['default', 'stop', 'revert'])
          .default('default')
      )

      .option('-c, --config <path>', 'Path to deploy config file', defaultDeployConfigFile)
      .description('Load config and run configured deploy scripts')
      .action(async (options: cliDeployOptions) => {
        log.debug(`Running cli deploy with options ${JSON.stringify(options)}`)
        await cliDeploy(options)
      })

    // CreateEnv command
    program
      .command('createEnv')
      .option('-c, --deployConfig <path>', 'Path to deploy config file', defaultDeployConfigFile)
      .addOption(
        new Option('-e, --environment <env>', 'Environment name from your deploy config')
      )
      .addOption(
        new Option('-b, --branch <branch>')
      )
      .action(async (options: cliCreateEnvOptions) => {
        log.debug(`Running cli createEnv with options ${JSON.stringify(options)}`)
        await cliCreateEnv(options)
      })

    // CreateCiConfig command
    program
      .command('createCiConfig')
      .option('-c, --deployConfig <path>', 'Path to deploy config file', defaultDeployConfigFile)
      .option('-d, --dryRun', 'Does not write any files, just report if there are any changes', false)
      .option('-o, --outputFile <path>', 'Your ci config yml file name', 'ci-tools-gl-config.yml')
      .action(async (options: cliCreateCiConfigOptions) => {
        log.debug(`Running cli createCiConfig with options ${JSON.stringify(options)}`)
        await cliCreateCiConfig(options)
      })

    await program.parseAsync(process.argv);
  } catch (error) {
    console.error(error)
    log.error(error)
    process.exit(1)
  }
}




initLogger()
cli()


